import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocationPermissionState, LocationService } from './location.service';

@Injectable({
  providedIn: 'root'
})
export class LocationGuardService {

  constructor(
    private router: Router,
    private locationService: LocationService
  ) {}

  async startMonitoringLocationPermission() {
    await this.locationService.startPermissionMonitoring();

    this.locationService.permissionState$.subscribe(state => {
      this.handlePermission(state);
    });
  }

  private handlePermission(state: LocationPermissionState) {
    if (state === 'denied' && this.hasAuthenticatedUser() && !this.isLoginRoute()) {
      this.forceLogout();
    }
  }

  private forceLogout() {
    sessionStorage.removeItem('currentUser');
    localStorage.removeItem('permissions');
    this.router.navigate(['/account/login'], {
      queryParams: { locationRequired: '1' },
      replaceUrl: true
    });
  }

  private hasAuthenticatedUser(): boolean {
    return !!sessionStorage.getItem('currentUser');
  }

  private isLoginRoute(): boolean {
    return this.router.url.startsWith('/account/login');
  }
}
